/**
 * Primary style guide configuration
 * Is included in the app as JS module as well as available as SASS variables
 */

var TOKENS = {
  ENVIRONMENT: 'production',
  // (dev|test|production)

  DEV_SHOW_GRID_DEFAULT: false,
  // on dev only
  DEV_SHOW_GRID_KEY_CODE: 13,
  // JS event key code to toggle baseline grid on dev environment

  DEFAULT_BROWSER_FONT_SIZE: 16,
  // [px]

  PORTAL_CONTAINER_ID: 'root-portal',
  PORTAL_CONTAINER_Z_INDEX: 1024,
  THEME: {
    light: 'light',
    dark: 'dark'
  },
  THEME_DEFAULT: 'light',
  THEME_PREFIX: 'theme-',
  BASE_GRID_UNIT: {
    // Base grid unit [bgu]
    value: '8px',
    variable: '--base-grid-unit'
  },
  BASE_FONT_WEIGHT_NORMAL: 'regular',
  BASE_FONT_WEIGHT_BOLD: 'bold',
  BREAKPOINT: {
    s: {
      width: 0
    },
    m: {
      width: 640
    },
    l: {
      width: 1024
    },
    xl: {
      width: 1280
    },
    xxl: {
      width: 1440
    }
  },
  BREAKPOINT_DPI: {
    'dpi-1': 1,
    'dpi-1-5': 1.5,
    'dpi-2': 2,
    'retina': 2,
    'dpi-3': 3,
    'dpi-4': 4
  },
  BREAKPOINT_DPI_DEFAULT: 'dpi-1',
  BREAKPOINT_PRINT: 'l',
  PALETTE: {
    white: {
      color: '#ffffff',
      canScale: false
    },
    black: {
      color: '#000000',
      canScale: false
    },
    gray: {
      color: '#6c6c6c',
      canScale: true
    },
    primary: {
      color: '#FFD740',
      canScale: true
    },
    secondary: {
      color: '#F4EBD9',
      canScale: true
    },
    success: {
      color: '#74D3AE',
      canScale: true
    },
    error: {
      color: '#B6402C',
      canScale: true
    },
    accent1: {
      color: '#A39A92',
      canScale: true
    }
  },
  PALETTE_LIGHTNESS_SCALE: [{
    key: -4,
    value: {
      default: -0.9,
      gray: -0.92,
      primary: -0.5,
      secondary: -0.49
    }
  }, {
    key: -3,
    value: {
      default: -0.75,
      gray: -0.68,
      primary: -0.35,
      secondary: -0.35
    }
  }, {
    key: -2,
    value: {
      default: -0.5,
      gray: -0.53,
      primary: -0.15,
      secondary: -0.21
    }
  }, {
    key: -1,
    value: {
      default: -0.25,
      gray: -0.41,
      primary: -0.05,
      secondary: -0.07
    }
  }, {
    key: 0,
    value: {
      default: 0
    }
  }, {
    key: 1,
    value: {
      default: 0.25,
      gray: 0.44
    }
  }, {
    key: 2,
    value: {
      default: 0.5,
      gray: 0.72
    }
  }, {
    key: 3,
    value: {
      default: 0.75,
      gray: 0.89
    }
  }, {
    key: 4,
    value: {
      default: 0.9,
      gray: 0.95,
      error: 0.97
    }
  }],
  PALETTE_OPACITY_SCALE: [{
    key: 0,
    value: 0
  }, {
    key: 1,
    value: 0.15
  }, {
    key: 2,
    value: 0.33
  }, {
    key: 3,
    value: 0.5
  }, {
    key: 4,
    value: 0.66
  }, {
    key: 5,
    value: 0.85
  }],
  TEXT_COLOR_PREFIX: 'color-',
  BACKGROUND_COLOR_PREFIX: 'bg-',
  TEXT_ALIGNMENT: {
    left: 'left',
    right: 'right',
    center: 'center',
    justify: 'justify'
  },
  TEXT_ALIGNMENT_DEFAULT: 'left',
  TEXT_ALIGNMENT_PREFIX: 'text-',
  DISPLAY_TYPE: {
    inline: 'inline',
    block: 'block',
    iblock: 'inline-block'
  },
  DISPLAY_TYPE_PREFIX: 'display-',
  MASK_TYPE: {
    xy: 'xy',
    y: 'y',
    x: 'x'
  },
  MASK_TYPE_PREFIX: 'mask-',
  HEADING_SIZE_SCALE: [{
    key: 1,
    breakpoint: {
      s: {
        size: 2,
        height: 3,
        margin: 2
      }
    }
  }, {
    key: 2,
    breakpoint: {
      s: {
        size: 2.25,
        height: 3,
        margin: 2
      }
    }
  }, {
    key: 3,
    breakpoint: {
      s: {
        size: 2.625,
        height: 4,
        margin: 2
      }
    }
  }, {
    key: 4,
    breakpoint: {
      s: {
        size: 3,
        height: 4,
        margin: 2
      }
    }
  }, {
    key: 5,
    breakpoint: {
      s: {
        size: 3,
        height: 4,
        margin: 2
      },
      m: {
        size: 4,
        height: 5,
        margin: 2
      }
    }
  }, {
    key: 6,
    breakpoint: {
      s: {
        size: 4,
        height: 5,
        margin: 2
      },
      m: {
        size: 5.25,
        height: 7,
        margin: 3
      }
    }
  }, {
    key: 7,
    breakpoint: {
      s: {
        size: 5.25,
        height: 7,
        margin: 3
      },
      m: {
        size: 7,
        height: 9,
        margin: 4,
        spacing: -0.5
      }
    }
  }],
  HEADING_SIZE_PREFIX: 'h-',
  ICON_SIZE_SCALE: [{
    key: 1,
    value: 2
  }, {
    key: 2,
    value: 3
  }, {
    key: 3,
    value: 4
  }, {
    key: 4,
    value: 6
  }, {
    key: 5,
    value: 8
  }, {
    key: 6,
    value: 12
  }, {
    key: 7,
    value: 16
  }],
  ICON_SIZE_PREFIX: 'size-',
  ICON_SIZE_DEFAULT: 2,
  BORDER_TYPE: {
    solid: '1px solid',
    dotted: '1px dotted',
    dashed: '1px dashed',
    thick: '2px solid'
  },
  BORDER_PREFIX: 'bd-',
  BORDER_RADIUS_BASE: '3px',
  BORDER_RADIUS_SCALE: [{
    key: 0,
    value: 0
  }, {
    key: 1,
    value: 1
  }, {
    key: 2,
    value: 2
  }, {
    key: 3,
    value: 4
  }, {
    key: 4,
    value: 6
  }, {
    key: 5,
    value: 9999
  }],
  BORDER_RADIUS_PREFIX: 'br-',
  CORNER_SIDE_ORDER: [{
    key: 'tl',
    value: 'top-left'
  }, {
    key: 'tr',
    value: 'top-right'
  }, {
    key: 'br',
    value: 'bottom-right'
  }, {
    key: 'bl',
    value: 'bottom-left'
  }],
  BOX_SIDE_ORDER: [{
    key: 't',
    value: 'top'
  }, {
    key: 'r',
    value: 'right'
  }, {
    key: 'b',
    value: 'bottom'
  }, {
    key: 'l',
    value: 'left'
  }],
  BOX_SHADOW_SCALE: [{
    key: 1,
    value: {
      sh1: '0 1px 2px'
    }
  }, {
    key: 2,
    value: {
      sh1: '0 1px 2px',
      sh2: '0 2px 4px'
    }
  }, {
    key: 3,
    value: {
      sh1: '0 1px 2px',
      sh2: '0 2px 4px',
      sh3: '0 4px 8px'
    }
  }, {
    key: 4,
    value: {
      sh1: '0 1px 2px',
      sh2: '0 2px 4px',
      sh3: '0 4px 8px',
      sh4: '0 8px 16px'
    }
  }, {
    key: 5,
    value: {
      sh1: '0 1px 2px',
      sh2: '0 2px 4px',
      sh3: '0 4px 8px',
      sh4: '0 8px 16px',
      sh5: '0 16px 32px'
    }
  }, {
    key: 6,
    value: {
      sh1: '0 1px 2px',
      sh2: '0 2px 4px',
      sh3: '0 4px 8px',
      sh4: '0 8px 16px',
      sh5: '0 16px 32px',
      sh6: '0 32px 64px'
    }
  }],
  BOX_SHADOW_PREFIX: 'bs-',
  ANIMATION_DURATION: {
    fastest: '100ms',
    faster: '150ms',
    fast: '200ms',
    normal: '300ms',
    slow: '400ms',
    slower: '500ms',
    slowest: '650ms'
  },
  ANIMATION_EASING: {
    linear: 'linear',
    easeInSoft: 'cubic-bezier(0.12, 0, 0.39, 0)',
    //easeInSine
    easeOutSoft: 'cubic-bezier(0.61, 1, 0.88, 1)',
    //easeOutSine
    easeSoft: 'cubic-bezier(0.37, 0, 0.63, 1)',
    //easeInOutSine
    easeIn: 'cubic-bezier(0.32, 0, 0.67, 0)',
    // easeInCubic
    easeOut: 'cubic-bezier(0.33, 1, 0.68, 1)',
    // easeOutCubic
    ease: 'cubic-bezier(0.65, 0, 0.35, 1)',
    // easeInOutCubic
    easeInStrong: 'cubic-bezier(0.64, 0, 0.78, 0)',
    // easeInQuint
    easeOutStrong: 'cubic-bezier(0.22, 1, 0.36, 1)',
    // easeOutQuint
    easeStrong: 'cubic-bezier(0.83, 0, 0.17, 1)',
    // easeInOutQuint
    easeInBack: 'cubic-bezier(0.36, 0, 0.66, -0.56)',
    // easeInBack
    easeOutBack: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
    // easeOutBack
    easeBack: 'cubic-bezier(0.68, -0.6, 0.32, 1.6)' // easeInOutBack
  },

  GRID_DEFAULT_COLUMNS: 12,
  FLEX_GAP: {
    padding: 'padding',
    margin: 'margin',
    none: 'none',
    both: 'both'
  },
  FLEX_GAP_PREFIX: 'gap-',
  FLEX_GAP_DEFAULT: 'none',
  BUTTON_KIND: {
    normal: 'normal',
    outline: 'outline',
    text: 'text'
  },
  BUTTON_KIND_PREFIX: 'kind-',
  BUTTON_KIND_DEFAULT: 'normal',
  BUTTON_COLOR: {
    primary: ["'primary'"],
    secondary: ["'secondary'"],
    success: ["'success'", 1],
    error: ["'error'"],
    white: ["'white'"],
    gray: ["'gray'", -4]
  },
  BUTTON_COLOR_PREFIX: 'bcolor-',
  BUTTON_COLOR_DEFAULT: 'primary',
  BUTTON_SIZE: {
    s: {
      font: 1.5,
      // [bgu]
      height: 4,
      // [bgu]
      padding: 2,
      // [bgu]
      icon: 2,
      // see ICON_SCALE_SIZE
      iconPadding: 0.5,
      // [bgu]
      corners: 0,
      // see BORDER_RADIUS_SCALE
      spacing: 1.5,
      // [px]
      iconOffset: 1 // [px]
    },

    m: {
      font: 1.75,
      height: 5,
      padding: 3,
      icon: 2,
      iconPadding: 0.5,
      corners: 0,
      spacing: 1.5,
      iconOffset: 1
    },
    l: {
      font: 2,
      height: 6,
      padding: 3,
      icon: 3,
      iconPadding: 1,
      corners: 0,
      spacing: 1.5,
      iconOffset: 0
    },
    xl: {
      font: 2.5,
      height: 8,
      padding: 4.5,
      icon: 4,
      iconPadding: 1.5,
      corners: 0,
      spacing: 1.5,
      iconOffset: 0
    }
  },
  BUTTON_SIZE_PREFIX: 'size-',
  BUTTON_SIZE_DEFAULT: 'm',
  BUTTON_WIDTH: {
    normal: 'normal',
    square: 'square',
    stretch: 'stretch'
  },
  BUTTON_WIDTH_PREFIX: 'width-',
  BUTTON_WIDTH_DEFAULT: 'normal',
  INPUT_BORDER_WIDTH: 1,
  // [px]
  INPUT_BORDER_COLOR: ["'gray'", 1],
  INPUT_ERROR_COLOR: ['error'],
  INPUT_TRANSITION_DURATION: 'fast',
  CHECKBOX_BORDER_RADIUS: 0,
  CHECKBOX_COLOR: ["'gray'", -4],
  CHECKBOX_BACKGROUND: ["'white'"],
  CHECKBOX_ICON_SIZE: 1,
  // see ICON_SIZE_SCALE
  CHECKBOX_ICON_PADDING: 0.25,
  // [bgu]
  CHECKBOX_LABEL_MARGIN: [0, 2, 0, 1],
  CHECKBOX_MARGIN: [0, 0, 1, 0],
  INPUT_SIZE: {
    s: {
      font: 1.75,
      // [bgu]
      height: 4,
      // [bgu]
      padding: 1,
      // [bgu]
      icon: 2,
      // see ICON_SCALE_SIZE
      corners: 0 // see BORDER_RADIUS_SCALE
    },

    m: {
      font: 2,
      height: 5,
      padding: 1.5,
      icon: 2,
      corners: 0
    },
    l: {
      font: 2.25,
      height: 6,
      padding: 2,
      icon: 2,
      corners: 0
    }
  },
  INPUT_SIZE_PREFIX: 'size-',
  INPUT_SIZE_DEFAULT: 'm',
  INPUT_KIND: {
    normal: 'normal',
    outline: 'outline'
  },
  INPUT_KIND_PREFIX: 'kind-',
  INPUT_KIND_DEFAULT: 'normal',
  INPUT_NUMBER_SHOW_SPINNER: true,
  SELECT_OPTION_LIST_SHADOW: 3,
  SELECT_OPTION_LIST_CORNER: 0,
  SELECT_OPTION_LIST_BOTTOM_MARGIN: 3,
  SELECT_DRAWER_SIZE: 's',
  OPTION_ANIMATION_DURATION: 'normal',
  OPTION_LIST_ANIMATION_DURATION: 'fastest',
  FIELD_TRANSITION_DURATION: 'slower',
  FIELD_TRANSITION_EASING: 'easeSoft',
  ASPECT_RATIO: [{
    key: '2x3',
    width: 2,
    height: 3
  }, {
    key: '3x4',
    width: 3,
    height: 4
  }, {
    key: '1x1',
    width: 1,
    height: 1
  }, {
    key: '4x3',
    width: 4,
    height: 3
  }, {
    key: '3x2',
    width: 3,
    height: 2
  }, {
    key: '16x9',
    width: 16,
    height: 9
  }],
  ASPECT_RATIO_PREFIX: 'ar-',
  ASPECT_RATIO_DEFAULT: '1x1',
  AVATAR_TEXT_COLOR: "'white'",
  AVATAR_BACKGROUND_DEFAULT: ['primary', -1],
  AVATAR_CORNER_DEFAULT: 3,
  // One of keys from ICON_SIZE_SCALE
  AVATAR_FONT_TO_WIDTH_RATIO: 0.33,
  DRAWER_POSITION: {
    top: 'top',
    bottom: 'bottom',
    left: 'left',
    right: 'right'
  },
  DRAWER_SIZE: {
    s: {
      s: {
        padding: 3,
        titleSize: 3,
        iconSize: 3,
        span: 'shrink'
      }
    },
    m: {
      s: {
        padding: 4,
        titleSize: 4,
        iconSize: 3,
        span: 12
      },
      m: {
        padding: 5,
        titleSize: 4,
        iconSize: 3,
        width: 60
      }
    },
    l: {
      s: {
        padding: 4,
        titleSize: 4,
        iconSize: 3,
        span: 12
      },
      m: {
        padding: 5,
        titleSize: 4,
        iconSize: 3,
        span: 6
      }
    },
    xl: {
      s: {
        padding: 4,
        titleSize: 4,
        iconSize: 3,
        span: 12
      },
      m: {
        padding: 5,
        titleSize: 4,
        iconSize: 3,
        span: 9
      }
    },
    xxl: {
      s: {
        padding: 4,
        titleSize: 6,
        iconSize: 4,
        span: 12
      },
      m: {
        padding: 6,
        titleSize: 5,
        iconSize: 4,
        span: 11
      }
    }
  },
  DRAWER_ANIMATION_DURATION: 'slow'
};

/**
 * Hack to serve same file in node 
 * for json-to-scss and to import in React app
 */

if (typeof module !== 'undefined' && module.exports) {
  module.exports = TOKENS;
} else {
  // eslint-disable-next-line
  eval('export default tokens');
}